import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DateRangePicker from 'react-bootstrap-daterangepicker';

const format = (date) => moment(date).format('YYYY-MM-DD');

function ResultsHeader(props) {
  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="results-header">Quick Stats</div>
        <div className="datepicker-container">
          <DateRangePicker
            startDate={props.startDate}
            endDate={props.endDate}
            onApply={(event, { startDate, endDate }) => {
              props.onRangeChange(startDate, endDate);
            }}
          >
            <div className="datepicker">
              <div className="datepicker-icon ">
                <i className="glyphicon glyphicon-calendar" />
              </div>
              {format(props.startDate)} – {format(props.endDate)}
            </div>
          </DateRangePicker>
        </div>
      </div>
    </div>
  );
}

ResultsHeader.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onRangeChange: PropTypes.func.isRequired,
};

export default ResultsHeader;
